import { render } from "./nq-assessment.vue?vue&type=template&id=709c3aa1&scoped=true"
import script from "./nq-assessment.vue?vue&type=script&lang=js"
export * from "./nq-assessment.vue?vue&type=script&lang=js"

import "./nq-assessment.vue?vue&type=style&index=0&id=709c3aa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709c3aa1"]])

export default __exports__